module.exports = __webpack_public_path__ + "static/media/amazon_smile.77d3aea7.png";